import { createResource, RouterContext } from 'react-resource-router';

import type {
  DeactivatedWorkspaceAccess,
  DeactivatedWorkspacesData,
} from 'src/sections/account/account-dormant-workspaces-part-of-ws-cleanup-resource';
import workspaceUrls from 'src/sections/workspace/urls';
import { authRequest, jsonHeaders } from 'src/utils/fetch';

export const dormantWorkspacePartOfWsCleanupResource = createResource({
  type: 'DORMANT_WORKSPACE_PART_OF_WS_CLEANUP',
  getKey: ({ match }: RouterContext) =>
    `dormant-workspace-part-of-ws-cleanup:${match.params.workspaceSlug}`,
  maxAge: 60 * 1000,
  getData: async ({ match }): Promise<DeactivatedWorkspaceAccess | null> => {
    const slug = match.params.workspaceSlug;
    if (!slug) {
      throw new Error(
        'Workspace slug is required for dormant workspace resource'
      );
    }
    // query all dormant workspaces and then filter by requested slug
    const response = await fetch(
      authRequest(workspaceUrls.api.internal.dormantWorkspaces(), {
        headers: jsonHeaders,
      })
    );

    if (!response.ok) {
      throw new Error(
        `Error fetching workspaces (${response.status}): ${response.statusText}`
      );
    }

    const deactivatedWorkspaces: DeactivatedWorkspacesData =
      await response.json();
    const deactivatedWorkspace =
      deactivatedWorkspaces.values?.find(w => w.workspace.slug === slug) ??
      null;

    if (!deactivatedWorkspace) {
      throw new Error(`Workspace ${slug} not found`);
    }

    return deactivatedWorkspace;
  },
});
